export const MAX_DIMENSIONS = 8;

export const MIN_DIMENSIONS = 1;

export const DEFAULT_COLUMNS = [
  'eo_click',
  'eo_install',
  'eo_reinstall',
  'eo_open',
  'eo_web_session_start',
  'PURCHASE',
  'revenue',
];

export const INIT_ACTIVE_TABLE_HEADER_COLUMN = 'eo_click';

export const EXPORT_FILE_NAME = 'roi-table-export';

export const EXPORT_CLOSE_TO = '/ads/roi-hub/analytics';

export const FEATURE_NAME = 'Roi Analytics';
